import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import axios from 'axios';
import { getImageUrl } from './utils/utils'; // Import the helper
import ToastPlugin from 'vue-toast-notification';
import 'vue-toast-notification/dist/theme-bootstrap.css';
// Import Bootstrap and custom CSS
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import './assets/css/utility.css';
import './assets/css/responsive.css';
import VueLazyload from 'vue3-lazyload';
// Set the base URL for all Axios requests for local
// axios.defaults.baseURL = 'http://dpg-backend.test/api';
// Set the base URL for all Axios requests for live
axios.defaults.baseURL = 'https://admin.dubaipetsgroomer.com/api';

const websiteName = 'Dubai Pets Groomer';
// Create the Vue app instance
const app = createApp(App);
// Register Axios as a global property
app.config.globalProperties.$axios = axios;
// Register the helper function globally
app.config.globalProperties.$getImageUrl = getImageUrl;
// Website Name
app.config.globalProperties.$websiteName = websiteName;
// Use the router and mount the app
app.use(ToastPlugin);
app.use(VueLazyload, {
  loading: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mP8/x8AAusB9QpqlPYAAAAASUVORK5CYII=',
  error: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mP8/x8AAusB9QpqlPYAAAAASUVORK5CYII='
});
// router.afterEach((to) => {
//   const canonicalUrl = window.location.origin + to.fullPath;

//   let link = document.querySelector("link[rel='canonical']");
//   if (link) {
//     link.setAttribute("href", canonicalUrl);
//   } else {
//     link = document.createElement("link");
//     link.setAttribute("rel", "canonical");
//     link.setAttribute("href", canonicalUrl);
//     document.head.appendChild(link);
//   }
// });
router.afterEach((to) => {
  const canonicalUrl = window.location.origin + to.fullPath;

  // Set/update canonical tag
  let canonicalLink = document.querySelector("link[rel='canonical']");
  if (canonicalLink) {
    canonicalLink.setAttribute("href", canonicalUrl);
  } else {
    canonicalLink = document.createElement("link");
    canonicalLink.setAttribute("rel", "canonical");
    canonicalLink.setAttribute("href", canonicalUrl);
    document.head.appendChild(canonicalLink);
  }

  // Set or remove noindex meta tag
  let robotsMeta = document.querySelector("meta[name='robots']");
  if (to.meta.noindex) {
    if (!robotsMeta) {
      robotsMeta = document.createElement("meta");
      robotsMeta.setAttribute("name", "robots");
      document.head.appendChild(robotsMeta);
    }
    robotsMeta.setAttribute("content", "noindex, nofollow");
  } else if (robotsMeta) {
    robotsMeta.remove(); // Remove if route does not require noindex
  }
});
app.use(router).mount('#app');
